import { QRCodeSVG } from "qrcode.react";
import { Sparkles } from "lucide-react";

const tierRing = {
  Bronze: "text-amber-200/90",
  Silver: "text-slate-200",
  Gold: "text-amber-300",
  Platinum: "text-amber-200",
};

export function LoyaltyCard({ customer, showQr = true }) {
  const tier = customer?.tier || "Bronze";
  return (
    <div
      data-testid="digital-loyalty-card"
      className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-[#3D181E] via-[#4A1D24] to-[#1F0A0E] text-stone-100 p-6 shadow-xl border border-amber-500/20"
    >
      <div className="absolute -right-8 -top-10 text-[9rem] font-serif font-bold text-white/5 select-none leading-none">VS</div>
      <div className="relative flex items-start justify-between">
        <div>
          <div className="flex items-center gap-1.5 text-[#C59B6C]">
            <Sparkles className="h-3.5 w-3.5" />
            <span className="text-[10px] tracking-[0.3em] font-semibold">VELOURS &amp; SILK</span>
          </div>
          <div className="text-xs text-stone-300/70 tracking-widest mt-0.5">SALON · TREUEKARTE</div>
        </div>
        <span className={`text-[10px] font-semibold uppercase tracking-widest px-2.5 py-1 rounded-full border border-amber-400/30 bg-black/20 ${tierRing[tier]}`}>
          {tier}
        </span>
      </div>

      <div className="relative mt-8 flex items-end justify-between">
        <div>
          <p className="text-[10px] uppercase tracking-widest text-stone-300/60">Mitglied</p>
          <p className="font-serif text-2xl text-stone-50 leading-tight" data-testid="loyalty-card-name">{customer?.first_name}</p>
          <p className="mt-3 text-[10px] uppercase tracking-widest text-stone-300/60">Punktestand</p>
          <p className="font-mono text-3xl tracking-wide text-[#E7C79A] font-bold" data-testid="loyalty-card-points">{customer?.points}</p>
        </div>
        {showQr && (
          <div className="rounded-xl bg-white p-2 shadow-lg" data-testid="loyalty-card-qr-code">
            <QRCodeSVG value={customer?.portal_token || ""} size={82} level="M" />
          </div>
        )}
      </div>
    </div>
  );
}
